<template>
  <v-dialog
    :width="videoWidth"
    :height="videoHeight"
    v-model="dialog"
    v-if="dialog"
    :content-class="contentClass"
    :transition="false"
  >
    <iframe
      id="player"
      :src="vidSrc"
      :width="videoWidth"
      :height="videoHeight"
      frameborder="0"
      allowfullscreen="true"
      v-if="dialog"
    ></iframe>
    <div class="video-prl">
      <Spinner />
    </div>
  </v-dialog>
</template>

<script>
import Spinner from '@/components/Spinner/Spinner';
export default {
  components: { Spinner },
  mounted() {
    this.$nuxt.$on('openVideo', this.openVideo);
  },
  data() {
    return {
      dialog: false,
      vidSrc: '',
      contentClass: 'video-modal',
    };
  },
  computed: {
    videoWidth() {
      if (this.$vuetify.breakpoint.smOnly) {
        return 512;
      } else if (this.$vuetify.breakpoint.mdOnly) {
        return 768;
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return 1024;
      } else {
        return 384;
      }
    },
    videoHeight() {
      if (this.$vuetify.breakpoint.smOnly) {
        return 288;
      } else if (this.$vuetify.breakpoint.mdOnly) {
        return 432;
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return 576;
      } else {
        return 216;
      }
    },
  },
  methods: {
    openVideo(src) {
      this.vidSrc = src;
      this.dialog = true;
    },
    closeVideo() {
      this.vidSrc = '';
      this.dialog = false;
    },
  },
  destroyed() {
    this.$nuxt.$off('openVideo');
  },
};
</script>

<style >
.v-dialog.video-modal {
  box-shadow: none;
}
.video-prl {
  position: absolute;
  margin: 0 auto;
  width: 80px !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
}

</style>